import { render, staticRenderFns } from "./freeLesson.vue?vue&type=template&id=7a8af6be&scoped=true"
import script from "./freeLesson.vue?vue&type=script&lang=js"
export * from "./freeLesson.vue?vue&type=script&lang=js"
import style0 from "./freeLesson.vue?vue&type=style&index=0&id=7a8af6be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8af6be",
  null
  
)

export default component.exports